import { createSelector } from 'reselect';
import { get } from 'lodash';

import { getCurrentLeg } from './screen';
import { AlertType, DefaultIntervalValue, PopupType } from '../reducers/alert';

const getAlerts = createSelector(
    (state) => get(state, 'alert', {}),
    (alert) => alert
);

export const getAlert = (type) =>
    createSelector(getCurrentLeg, getAlerts, (leg = {}, alert) => {
        const { allowed, interval, timeoutID, nextAlert } = alert;
        const allowedAlert = get(allowed, `${type}`, false);
        const intervalAlert = get(interval, `${type}`, DefaultIntervalValue[type]);
        const popupType = PopupType[type];
        const timeoutId = get(timeoutID, `${type}.${leg.id}`, null);
        const nextDate = get(nextAlert, `${type}.${leg.id}`, null);

        return {
            type,
            popupType,
            legId: leg.id,
            allowed: allowedAlert,
            interval: +intervalAlert * 60 * 1000,
            timeoutID: timeoutId,
            nextAlert: nextDate,
        };
    });

export const altitudeAlertSelector = getAlert(AlertType.ALTITUDE);

export const fuelAlertSelector = getAlert(AlertType.FUEL);

export const AlertSelector = {
    [AlertType.ALTITUDE]: altitudeAlertSelector,
    [AlertType.FUEL]: fuelAlertSelector,
};
